import { render, staticRenderFns } from "./PaginationPrevIcon.vue?vue&type=template&id=8511b0bc"
var script = {}
import style0 from "./PaginationPrevIcon.vue?vue&type=style&index=0&id=8511b0bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
